export const ASSISE_CREATE_RESET = "ASSISE_CREATE_RESET";
export const ASSISE_CREATE_SET_CREATED = "ASSISE_CREATE_SET_CREATED";
export const ASSISE_CREATE_SET_ERROR = "ASSISE_CREATE_SET_ERROR";
export const ASSISE_CREATE_SET_VIOLATIONS = "ASSISE_CREATE_SET_VIOLATIONS";
export const ASSISE_CREATE_TOGGLE_LOADING = "ASSISE_CREATE_TOGGLE_LOADING";
export const ASSISE_CREATE_SET_RETRIEVED = "ASSISE_CREATE_SET_RETRIEVED";
